(() => {
  if (window.productFaqInitialized) return;

  window.productFaqInitialized = true;

  document.addEventListener('click', (event) => {
    const question = event.target.closest('[data-faq-question]');

    if (!question) return;

    const faq = question.closest('[data-product-faq]');
    const item = question.closest('.faq-item');

    if (!faq || !item) return;

    const answerId = question.getAttribute('aria-controls');
    const answer = document.getElementById(answerId);
    const willOpen = !item.classList.contains('open');

    item.classList.toggle('open', willOpen);
    question.setAttribute('aria-expanded', String(willOpen));

    if (answer) {
      answer.hidden = false;
      answer.setAttribute('aria-hidden', String(!willOpen));
    }
  });
})();